export enum RedemptionStatusEnum {
  READY_TO_RELEASE = 'READY_TO_RELEASE',
  REDEEMED = 'REDEEMED',
  SENT_TO_REDEMPTION = 'SENT_TO_REDEMPTION',
}

export enum RedemptionPendingStatusEnum {
  PENDING = 'PENDING',
  PENDING_PROCESSING = 'PENDING_PROCESSING',
}
